import Icon from '@components/icon'
import BaseInternalLink from '@components/link/base-internal-link'
import Photo from '@components/photo'
import { SanityBlogPostWithoutBody } from '@data/sanity/queries/types/blog'
import { PageType, getPageUrl } from '@lib/routes'

interface BlogPostReadMoreProps {
  posts?: Array<SanityBlogPostWithoutBody>
}

const BlogPostReadMore = ({ posts }: BlogPostReadMoreProps) => {
  if (!posts || !posts.length) {
    return null
  }

  return (
    <section className="container my-10">
      <div className="border-t border-current py-14">
        <div className="w-full max-w-3xl mx-auto">
          {/* TODO: String */}
          <h5 className="is-h2 mb-8">Read more</h5>
          <div className="flex flex-col gap-y-7">
            {posts.map((post) => (
              <div
                key={`read-${post.slug}`}
                className="w-full flex flex-col items-center sm:flex-row gap-x-6"
              >
                {post.coverImage && (
                  <div className="relative w-full sm:w-[150px] sm:h-[90px] pb-[56.25%] sm:p-0 rounded-md overflow-hidden shrink-0 mb-3 sm:mb-0">
                    <Photo
                      image={{
                        ...post.coverImage,
                        borderRadius: 'none',
                      }}
                      fill
                      imageClassName="object-cover"
                    />
                  </div>
                )}
                <div>
                  <h4 className="is-h3 mb-3">{post.title}</h4>
                  <BaseInternalLink
                    href={getPageUrl(PageType.BLOG_POST, post.slug)}
                    role="link"
                    className="uppercase inline-flex items-center font-medium text-sm"
                  >
                    <Icon
                      id={`read-${post.slug}-icon`}
                      name="ArrowRight"
                      className="mr-2 text-2xl"
                    ></Icon>
                    Read More
                  </BaseInternalLink>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default BlogPostReadMore
